import { StyleSheet } from 'react-native';

import { EnhancedInlineAlert } from '@fhs/ui';
import {
  CHECKOUT_PAYMENT_ERROR_ALERT,
  CHECKOUT_PRICING_ALERT,
} from '@fhs-legacy/frontend/src/utils/test-ids';

import type { PaymentPipelineError } from '../../../payment/payment-types';

export function PricingAlert() {
  return (
    <EnhancedInlineAlert
      status="error"
      title="Pricing Error"
      message="There was an error processing your order. Please try again. Error code: (Price Mutation Error)"
      isDismissable={false}
      onDismiss={() => {}}
      style={styles.alert}
      testID={CHECKOUT_PRICING_ALERT}
    />
  );
}

export function PaymentErrorAlert({
  error,
  onClear,
}: {
  error: PaymentPipelineError;
  onClear: () => void;
}) {
  // TODO: for warnings if implemented
  const isWarning = false;

  const isDuplicateOrderError = error.code === 'COMMIT_ORDER_COOLING_PERIOD';
  const title = isDuplicateOrderError
    ? 'Duplicate Orders'
    : isWarning
      ? 'Payment Cancelled'
      : 'Payment Error';

  return (
    <EnhancedInlineAlert
      status={isWarning ? 'warning' : 'error'}
      title={title}
      message={`${error.userMessage || error.message}`}
      isDismissable
      onDismiss={onClear}
      style={styles.alert}
      testID={CHECKOUT_PAYMENT_ERROR_ALERT}
    />
  );
}

const styles = StyleSheet.create({
  alert: { marginBottom: 4, borderRadius: 2 },
});
